module.exports = __webpack_public_path__ + "media/bip_duplicado.cfbe52f5.mp3";